const ready = require("%helpers%/document-ready.js");

ready(function() {

  const $btns = $(".panel__menu-btn");
  const $menu = $(".mobile-menu");
  const $page = $("body, html");
  const $mobileMenuItems = $(".mobile-menu__item");

  // -- Functions BEGIN
  const changeStates = () => {
    $btns.on("click", function () {
      $page.toggleClass("page-fixed");
      $btns.toggleClass("panel__menu-btn_active");
      $menu.toggleClass("mobile-menu_active");
    });
  };

  const hideMenuWhenClickLinks = () => {
    $mobileMenuItems.on("click", function () {
      $page.toggleClass("page-fixed");
      $menu.removeClass("mobile-menu_active");
      $btns.removeClass("panel__menu-btn_active");
    });
  };
  // -- Functions END

  if ( $btns.length && $menu.length ) changeStates();
  if ( $mobileMenuItems.length && $page.length ) hideMenuWhenClickLinks();

});
